// extracted by mini-css-extract-plugin
module.exports = {"breakTablet":"650px","breakDesktop":"992px","breakHd":"1200px"};